import { reactive, ref } from "vue";
import { getExecInscriptionItem, updateExecInscription } from "../api";

export function useExecInscriptionItem(uuid) {
  const form = reactive({
    template_code: null,
    state_duty: null,
    number_certified_copies: null,
    status: "PROJECT",
    content: null,
    content_kz: null,
    content_en: null,
    contract_amount: 0,
    languages: [],
    fields: {},
  });

  const loading = ref(false);

  async function fetchExecInscription(id) {
    const data = await getExecInscriptionItem(id || uuid.value);
    if (data?.success && data.payload) {
      Object.assign(form, data.payload);
    }
    return data;
  }

  async function updateExecInscriptionItem(payload, isNotifyDisabled) {
    const data = await updateExecInscription(
      uuid.value,
      payload,
      isNotifyDisabled
    );
    return data;
  }

  return {
    form,
    loading,
    fetchExecInscription,
    updateExecInscriptionItem,
  };
}
